import React__default, { useState, useCallback } from 'react';
import Modal from 'react-modal';
import { isNextJS } from '../utils.js';
import ImageAdapter from '../Image/Image.js';
import { PlayIcon, CloseIcon } from './Icons/Svgs.js';
import { ButtonV2 } from '../ButtonV2/ButtonV2.js';
import classNames from 'classnames';
import { AspectRatio } from '../AspectRatio/AspectRatio.js';
import { FontAwesomeIcon } from '../node_modules/@breville-fortawesome/react-fontawesome/index.es.js';

const VideoModal = (props) => {
    var _a;
    const isNext = isNextJS();
    const { url, light, modalTrigger, children, aspectRatio, videoBtnLabel = 'Play Video', videoBtnProps = { fill: 'filled', variant: 'white' }, videoIconName, videoIconPrefix, videoIconSize, videoIconColor, imageProps } = props;
    const [isOpen, setIsOpen] = useState(false);
    const youtubeVideoId = (_a = url === null || url === void 0 ? void 0 : url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)) === null || _a === void 0 ? void 0 : _a.pop();
    const backgroundImage = light || `https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`;
    const openModal = useCallback(() => {
        setIsOpen(true);
    }, [isOpen]);
    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, [isOpen]);
    function handleKeyDown(e) {
        e.preventDefault();
        if (e.key === 'Enter') {
            setIsOpen(true);
        }
    }
    return (React__default.createElement("div", { className: 'xps-video-modal' },
        (!modalTrigger || modalTrigger === 'backgroundImage') &&
            React__default.createElement("div", { className: classNames('xps-video-modal-background-image-contaner', { 'nextjs-image-container': isNext }), role: 'button', tabIndex: 0, onClick: openModal, onKeyDown: handleKeyDown },
                React__default.createElement(AspectRatio, Object.assign({}, aspectRatio),
                    React__default.createElement(ImageAdapter, Object.assign({ src: backgroundImage }, imageProps))),
                videoIconName ? React__default.createElement(FontAwesomeIcon, { icon: { prefix: videoIconPrefix, iconName: videoIconName }, size: videoIconSize, className: classNames('xps-video-modal__fa-icon', `xps-video-modal__fa-icon--${videoIconColor}`) }) :
                    React__default.createElement("span", { className: 'xps-video-modal-play-icon' },
                        React__default.createElement(PlayIcon, null))),
        modalTrigger === 'button' &&
            React__default.createElement(ButtonV2, Object.assign({ tabIndex: 0, onClick: openModal, text: videoBtnLabel, icon: 'play' }, videoBtnProps)),
        React__default.createElement(Modal, { isOpen: isOpen, onRequestClose: closeModal, overlayClassName: 'xps-video-modal-overlay', className: 'xps-video-modal-content' },
            React__default.createElement("span", { tabIndex: 0, className: 'xps-video-modal-overlay-close-button', role: 'button', "data-btn-text": 'Close', onClick: closeModal },
                React__default.createElement(CloseIcon, null)),
            children)));
};

export { VideoModal };
//# sourceMappingURL=VideoModal.js.map
